import { app } from '../app'
import { createApp } from 'vue'
import { vuetify } from '../vuetify'
import { errorMixin } from '../mixins/error-mixin'
import { i18n } from '../i18n'
import { initLightbox } from '../lightbox'

createApp({
  data () {
    return {
      menu: false
    }
  },
  components: {
  },
  mounted () {
    initLightbox()
  },
  extends: app,
  mixins: [errorMixin]
})
  .use(vuetify)
  .use(i18n)
  .mount('#app')
